module.exports = __webpack_public_path__ + "img/guias-consumidor.fb39387e.svg";